import React from "react";
import { Footer } from "../../Components/Footer/Footer";
import { Header } from "../../Components/Header/Header";
import { MyOrdersBox } from "../../Components/MyOrdersBox/MyOrdersBox";
import { PageHeader } from "../../Components/PageHeader/PageHeader";
import SeoDefault from "../../Components/Seo/SeoDefault";
import { MyAccountMenu } from "../MyAccount/MyAccount";
import { enviroment } from "../../enviroment";

export const MyOrders = () => {

  return (
    <React.Fragment>
      <SeoDefault
        title={`My Orders - ${enviroment.BUSINESS_NAME}`}
        description={`View your order history and track purchases at ${enviroment.BUSINESS_NAME}.`}
        keywords={`${enviroment.BUSINESS_NAME} orders, order history, track orders`}
        canonicalUrl={`${process.env.REACT_APP_URL}/my-orders`}
        pageType="website"
        robots="noindex"
        breadcrumbItems={[
          { name: "Home", url: `${process.env.REACT_APP_URL}/` },
          { name: "My Orders", url: `${process.env.REACT_APP_URL}/my-orders` },
        ]}
      />
      <div className="hideInDesktop">
        <PageHeader title="My Orders" />
        <MyOrdersBox />
      </div>

      <div className="hideInMobile">
        <Header />
        <div className="col-12 d-inline-flex mt-4">
          <div className="container">
            <div className="d-flex gap-3 col-12 align-items-start">
              <MyAccountMenu />
              <div className="d-flex flex-grow-1">
                <MyOrdersBox />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </React.Fragment>
  )
}